import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

import { useOpeningHours } from '../hooks/useOpeningHours'
// import { getHolidays } from '../utils/getHolidays'
import { holidays, IHoliday } from '../data/holidays'

export const IsOfficeOpen = () => {
  dayjs.extend(isBetween)
  const { openingHours } = useOpeningHours()
  // const [holidays, setHolidays] = useState<IHoliday[]>()
  const [isOpenedNow, setIsOpenedNow] = useState<boolean>(false)
  const [isTodayHoliday, setIsTodayHoliday] = useState<boolean>(true)
  const dayOfWeek = dayjs().get('day')
  const today = dayjs().format('Y-M-D')

  const checkOpenedNow = () => {
    if (openingHours) {
      const openingHoursToday = openingHours?.days?.find(
        (day, index) => index + 1 === dayOfWeek,
      )!

      if (!openingHoursToday) {
        return false
      }

      const { from, to } = openingHoursToday
      const [fromHour, fromMinute] = from?.split(':')!
      const [toHour, toMinute] = to?.split(':')!
      const _from = dayjs()
        .hour(parseInt(fromHour))
        .minute(parseInt(fromMinute))
        .second(0)
      const _to = dayjs()
        .hour(parseInt(toHour))
        .minute(parseInt(toMinute))
        .second(0)

      return dayjs().isBetween(_from, _to, 'minute')
    }

    return false
  }

  useEffect(() => {
    ;(async () => {
      /** Get holidays from API */
      // const newHolidays = await getHolidays()
      // setHolidays(newHolidays)

      const newIsTodayHoliday = !!holidays?.find(
        (holiday) => holiday.date.iso === today,
      )

      setIsTodayHoliday(newIsTodayHoliday)
      setIsOpenedNow(checkOpenedNow())
    })()
  }, [])

  if (isTodayHoliday || !isOpenedNow) {
    return null
  }

  return (
    <div className="px-4 py-1 bg-green-100 font-semibold rounded text-sm text-green-800">
      Nyní otevřeno
    </div>
  )
}
